// extracted by mini-css-extract-plugin
var _1 = "PopupHeader_backButton__nM9NE";
var _2 = "PopupHeader_content__i14Qi";
var _3 = "PopupHeader_headerIcon__EX6yq";
var _4 = "PopupHeader_wrapper__Rd9dA";
export { _1 as "backButton", _2 as "content", _3 as "headerIcon", _4 as "wrapper" }
